import { isObject } from 'lodash';
const getFileNameByUrl = (url: string) => {
    const urlObj = url ? new URL(url) : null;
    if (urlObj) {
        const { pathname = '' } = urlObj;
        return pathname.substring(pathname.lastIndexOf('/') + 1);
    }
    return '';
};

const imgList = [
    'png',
    'jpg',
    'jpeg',
    'bmp',
    'gif',
    'tif',
    'webp',
    'apng',
    'svg',
]; //图片文件的后缀名
const videoList = [
    'mp4',
    'm2v',
    'mkv',
    'rmvb',
    'wmv',
    'avi',
    'flv',
    'mov',
    'm4v',
];
const radioList = ['mp3', 'wav', 'wmv', 'm4a'];

const OSSHost = {
    'customer-service-center': 'https://customer-service.popmart.com',
    'service-center-work-order': 'https://service-center.popmart.com',
    // 'clink2-sh-resource':
    //     'https://clink2-sh-resource.oss-cn-shanghai.aliyuncs.com',
};

const getFileSuffix = (fileName: string) => {
    let suffix = '';

    if (fileName) {
        const flieArr = fileName.split('?')[0].split('.');
        suffix = flieArr[flieArr.length - 1];
    }

    if (!suffix) return '';
    suffix = suffix.toLocaleLowerCase();
    return suffix;
};
const getFileType = (fileName: string) => {
    const suffix = getFileSuffix(fileName);

    if (!suffix) return '';

    if (imgList.includes(suffix)) {
        return 'image';
    }
    if (videoList.includes(suffix)) {
        return 'video';
    }
    if (radioList.includes(suffix)) {
        return 'radio';
    }

    // 可能是没有拿到后缀的情况
    if (suffix.length > 10) {
        const query = fileName.split('?')[1];
        if (query) {
            if (query.includes('image')) {
                return 'image';
            }
            // FIX: 音频 / 视频 query 参数待定，没有找到对应的文件
            if (query.includes('video')) {
                return 'video';
            }
            if (query.includes('radio')) {
                return 'radio';
            }
        }
    }

    // FIX: 扩展其他类型
    return 'other';
};
const getUuid = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function (c) {
            const r = (Math.random() * 16) | 0,
                v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        },
    );
};

// function getBase64Image(img) {
//     let canvas = document.createElement('canvas');
//     canvas.width = img.width;
//     canvas.height = img.height;
//     let ctx = canvas.getContext('2d');
//     ctx?.drawImage(img, 0, 0, img.width, img.height);
//     let ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase();
//     // img.src = 'IMGURL';
//     let dataURL = canvas.toBlob((blob) => {
//         console.log(blob);
//     }, 'image/' + ext);
//     console.log(canvas);

//     document.getElementById('root')?.append(canvas);

//     return dataURL;
// }

// function btof(data, fileName) {
//     const dataArr = data.split(',');
//     const byteString = atob(dataArr[1]);

//     const options = {
//         type: 'image/jpeg',
//         endings: 'native',
//     };
//     const u8Arr = new Uint8Array(byteString.length);
//     for (let i = 0; i < byteString.length; i++) {
//         u8Arr[i] = byteString.charCodeAt(i);
//     }
//     return new File([u8Arr], fileName + '.jpeg', options);
// }

function urlToFile(imgUrl: string): Promise<File> {
    let fileName = getFileNameByUrl(imgUrl);
    let type = fileName.split('.').pop();
    return new Promise((resolve, reject) => {
        try {
            const url = new URL(imgUrl);
            const host = url.host.split('.')[0];
            let downloadLink = imgUrl;
            if (OSSHost[host]) {
                downloadLink = `${
                    OSSHost[host] || 'https://service-center.popmart.com'
                }${url.pathname}`;
            }
            dataURLtoBlob(downloadLink, function (blobData) {
                let file = new File([blobData], fileName || '', {
                    type: 'image/' + type,
                });
                resolve(file);
            });
        } catch (e) {
            reject(e);
        }
    });
}
// 图片url格式转为blob格式
function dataURLtoBlob(dataurl: string, callback: (file: Blob) => void) {
    let xhr = new XMLHttpRequest();
    xhr.open('get', dataurl, true);
    xhr.responseType = 'blob';
    xhr.setRequestHeader('Origin', location.origin);
    xhr.onload = function () {
        if (this.status === 200) {
            let blob = this.response;
            callback(blob);
        }
    };
    xhr.send();
}

const session = {
    set: (key: string, data: any) => {
        try {
            if (isObject(data)) {
                const storeData = JSON.stringify(data);
                sessionStorage.setItem(key, storeData);
                sessionStorage.setItem(key + '_time', new Date().getTime());
            }
        } catch (e) {
            sessionStorage.setItem(key, data);
            sessionStorage.setItem(key + '_time', new Date().getTime());
        }
    },
    /**
     *
     * @param key
     * @param indate 有效期，毫秒级别，超过有效期，返回null
     * @returns
     */
    get: (key: string, indate?: number) => {
        try {
            const data = sessionStorage.getItem(key);
            if (data) {
                if (indate) {
                    const date = sessionStorage.getItem(key + '_time');
                    if (date && indate < Date.now() - Number(date)) {
                        sessionStorage.removeItem(key);
                        sessionStorage.removeItem(key + '_time');
                        return null;
                    }
                }
                sessionStorage.setItem(key + '_time', new Date().getTime());
                return JSON.stringify(data);
            }

            return null;
        } catch (e) {
            sessionStorage.setItem(key + '_time', new Date().getTime());
            return sessionStorage.getItem(key);
        }
    },
};

const local = {
    set: (key: string, data: any) => {
        try {
            const storeData = JSON.stringify(data);
            localStorage.setItem(key, storeData);
        } catch (e) {
            localStorage.setItem(key, data);
        }
    },
    get: (key: string) => {
        try {
            return JSON.stringify(localStorage.getItem(key));
        } catch (e) {
            return localStorage.getItem(key);
        }
    },
};

export const getTextByHtml = (content: string, limit = 100) => {
    const str = content?.replace(/<[^<>]+>/g, '') || '';
    if (limit && str.length > limit) {
        return str?.slice(0, limit) + '...';
    }
    return str || '-';
};

export {
    getFileNameByUrl,
    getFileType,
    getFileSuffix,
    getUuid,
    urlToFile,
    session,
    local,
};
